var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 6,
    viewBox: "0 0 13 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.923026 0.38394C1.1252 0.148069 1.48031 0.120753 1.71618 0.322928L6.60011 4.50915L11.484 0.322929C11.7199 0.120754 12.075 0.14807 12.2772 0.383941C12.4794 0.619811 12.4521 0.974917 12.2162 1.17709L6.96618 5.67709C6.75553 5.85765 6.44469 5.85765 6.23404 5.67709L0.984038 1.17709C0.748167 0.974917 0.720851 0.619811 0.923026 0.38394Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.f03955f83d3bd8ff3179530ad69f69c4.svg";
export { ForwardRef as ReactComponent };